import React, { FC } from 'react';

import { Box, Stack } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

import {
  DetailsIdentifier,
  DocumentsIcon,
  IconTypes,
  InformationAlert,
  Modal,
  PageHeaderWithIcon,
  Tabs,
} from 'components/index';
import { useResourceType } from 'containers/App/hooks/useResourceType';
import { useInventoryContext } from 'containers/Inventory/CloudInventory/hooks/context';
import { useCloudAccountId } from 'containers/Setup/CloudAccounts/utils';

import { AddContextForm } from './AddContextForm';
import { DetachContext } from './DetachContext';

interface Props {
  isOpen: boolean;
  onClose: (isSubmit?: boolean) => void;
}

export const AddContext: FC<Props> = props => {
  const { isOpen, onClose } = props;
  const { currentInstance } = useInventoryContext();
  const { renderAccountNameAndID } = useCloudAccountId();
  const { getCloudNativeName } = useResourceType();
  // Removed unused isDisabled state: the OK footer that read it was commented out.
  const [tab, setTab] = React.useState(0);

  //const handleSubmit = () => {}

  const items = [
    {
      title: 'Attach Context',
      key: 'attach',
      component: <AddContextForm onClose={onClose} />,
    },
    {
      title: 'Detach Context',
      key: 'detach',
      component: <DetachContext onClose={onClose} />,
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={
        <PageHeaderWithIcon
          label="Configure Context Label"
          iconType={IconTypes.Tag}
          iconBgColor={colorOpacity(customTheme.colors.blue['300'], 0.2)}
          iconColor={customTheme.colors.blue['300']}
          useCustomColor
          border={false}
        />
      }
      size="2xl"
      body={
        <Stack spacing={4}>
          <InformationAlert
            description="Context labels are applied within Ariksa to enrich insights
            for detection, prioritization, investigation and response"
            icon={<DocumentsIcon color={customTheme.colors.primary} />}
            border="none"
            //bg="#fcf1d1"
          />
          <Box pt={2}>
            <DetailsIdentifier label="Resource" value={currentInstance.name} />
          </Box>
          <DetailsIdentifier
            label="Cloud ID"
            value={currentInstance.resource_id}
          />
          <DetailsIdentifier
            label="Account"
            value={renderAccountNameAndID(currentInstance.account)}
          />
          <DetailsIdentifier
            label="Type"
            value={getCloudNativeName(currentInstance.native_name)}
          />
          <Box />
          <Tabs items={items} onChange={setTab} currentIndex={tab} />
        </Stack>
      }
    />
  );
};
